var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.invalidLink)?_c('div',[_c('h3',{staticClass:"text-negative text-center"},[_vm._v("Sorry! This request is invalid!")])]):(_vm.resolvingToken)?_c('div',{staticClass:"full-height row justify-center items-center"},[_c('q-spinner',{attrs:{"color":"primary","size":"md"}})],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }